import './wdyr';
import 'services/firebase';
import React from 'react';
import ReactDOM from 'react-dom/client';

import segmentInit from 'services/segment';
import loadDelightedScript from 'services/delighted';

import { config } from '@ld/core';

// local
import App from './app';
import reportWebVitals from './reportWebVitals';

// styles
import 'react-phone-number-input/style.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
segmentInit(config.segmentApiKey);
loadDelightedScript(config.delightedApiKey);
